import React, { useState } from 'react';
import Modal from '../../../components/Common/modal/Modal';
import PlanSelector from '../Selectors/PlanSelector';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/store';
import { generateNewInviteLink } from './service/InviteUser.service';
import Loader from '../../../components/Common/Loader';
import { Toast } from '../../../components/Common/Toast';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faToggleOff, faToggleOn } from '@fortawesome/free-solid-svg-icons';
import UserTypeSelector from '../Selectors/UserTypeSelector';
import { UserTypeEnum } from '../../../interfaces/user.interface';

const InviteUser = () => {
  const allUserPlans = useSelector((state: RootState) => state.app.allUserPlans);
  const [isModalVisible, setIsModalVisible] = useState<boolean>(false);
  const [selectedPlanId, setSelectedPlanId] = useState<string | null>(null);
  const [selectedUserType, setSelectedUserType] = useState<UserTypeEnum | null>(null);
  const [requirePayment, setRequirePayment] = useState<boolean>(false);
  const [generatedInviteLink, setGeneratedInviteLink] = useState<string | null>(null);
  const [copied, setCopied] = useState(false);
  const [generateLoader, setGenerateLoader] = useState(false);


  const inviteUser = () => {
    setIsModalVisible(true);
  };

  const handleSelectedPlan = (planId: string) => {
    setSelectedPlanId(planId);
  };

  const handleSelectedUserType = (userType: UserTypeEnum) => {
    setSelectedUserType(userType);
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(generatedInviteLink || '').then(() => {
      setCopied(true);
      Toast('Link copied successfully', false);

      setTimeout(() => setCopied(false), 2000);
    });
  };

  const close = () => {
    setIsModalVisible(false);
    setGeneratedInviteLink(null);
    setGenerateLoader(false);
    setSelectedPlanId(null);
    setRequirePayment(false);
  };

  const generateInviteLink = () => {
    if (!selectedPlanId || !selectedUserType) return;
    setGeneratedInviteLink(null);
    setGenerateLoader(true);
    generateNewInviteLink(selectedPlanId, selectedUserType, requirePayment).then((response) => {
      setGeneratedInviteLink(response);
    }).finally(() => {
      setGenerateLoader(false);
    });
  };

  return (
    <>
      {isModalVisible && (
        <Modal
          title={`Generate Invite Link`}
          className={'global-absolute-popup-style'}
          showSubmitButton={false}
          showCloseButton={false}
          showTopRightCloseButton={true}
          showCloseButtonFunction={close}
        >
          <div className="flex flex-col">
            <div className="flex w-full">
              <PlanSelector allUserPlans={allUserPlans} notUserOptionAllPlans={true}
                            handleSelectedPlan={handleSelectedPlan}></PlanSelector>
              <div className="flex items-center ml-4 gap-1">
                <label className="font-medium">Payment: </label>
                <FontAwesomeIcon
                  icon={requirePayment ? faToggleOn : faToggleOff}
                  className={`h-8 w-8 cursor-pointer ${
                    requirePayment ? 'text-storygreen' : 'text-red-500'
                  } `}
                  title={requirePayment ? 'Deactivate ' : 'Activate '}
                  onClick={() => setRequirePayment(!requirePayment)}
                />
              </div>
            </div>
            <div className="flex w-full mt-4">
              <UserTypeSelector handleSelectedUserType={handleSelectedUserType}></UserTypeSelector>
            </div>

            <div className="flex justify-center w-full mt-6">
              {generatedInviteLink && <div className="flex items-baseline w-full">
                <input
                  type="text"
                  name="lastName"
                  value={generatedInviteLink || ''}
                  readOnly={true}
                  className="mt-1 p-2 w-full rounded-md border border-gray-300"
                />
                {/* Copy Button */}
                <button
                  onClick={handleCopy}
                  className="ml-2 px-3 py-1 bg-storyblue text-white rounded-lg hover:bg-blue-600 transition"
                >
                  {copied ? 'Copied!' : 'Copy'}
                </button>
              </div>}
            </div>
            <div className="flex justify-center w-full space-x-4 mt-6 relative">
              {generatedInviteLink && (
                <button
                  className="bg-gray-200 text-gray-700 disabled:bg-gray-500 font-medium px-6 py-2 rounded-md shadow hover:bg-gray-300 transition flex items-center absolute left-0"
                  onClick={generateInviteLink}
                  disabled={!selectedPlanId || !selectedUserType}
                >
                  Regenerate
                  {generateLoader && <Loader loader={generateLoader} dimentions={'w-6 h-6'} />}
                </button>
              )}
              {!generatedInviteLink
                ? <button
                  className="bg-storyblueButton disabled:bg-gray-500 text-white font-medium px-6 py-2 rounded-md shadow hover:bg-storyblue transition flex items-center"
                  onClick={generateInviteLink}
                  disabled={!selectedPlanId || !selectedUserType}
                >
                  Generate
                  {generateLoader && <Loader loader={generateLoader} dimentions={'w-6 h-6'} />}
                </button>
                : <button
                  className="bg-storyblueButton  text-white font-medium px-6 py-2 rounded-md shadow hover:bg-storyblue transition"
                  onClick={handleCopy}
                >
                  Copy
                </button>}

              <button
                className="bg-gray-200 text-gray-700 font-medium px-6 py-2 rounded-md shadow hover:bg-gray-300 transition"
                onClick={close}
              >
                Close
              </button>
            </div>
          </div>
        </Modal>
      )}
      <div className="flex">
        <button
          onClick={() => inviteUser()}
          className="flex justify-center bg-storyblue text-white font-bold rounded-md p-1 pl-2 pr-2"
        >
          Invite User
        </button>
      </div>
    </>
  );
};
export default InviteUser;
